var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _require = require('crypto'),
    randomBytes = _require.randomBytes;

var _require2 = require('../../help/key_object'),
    createSecretKey = _require2.createSecretKey;

var base64url = require('../../help/base64url');

var _require3 = require('../../help/consts'),
    THUMBPRINT_MATERIAL = _require3.THUMBPRINT_MATERIAL,
    PUBLIC_MEMBERS = _require3.PUBLIC_MEMBERS,
    PRIVATE_MEMBERS = _require3.PRIVATE_MEMBERS,
    KEY_MANAGEMENT_DECRYPT = _require3.KEY_MANAGEMENT_DECRYPT,
    KEY_MANAGEMENT_ENCRYPT = _require3.KEY_MANAGEMENT_ENCRYPT,
    KEYOBJECT = _require3.KEYOBJECT;

var Key = require('./base');

var OCT_PUBLIC = new Set();
Object.freeze(OCT_PUBLIC);
var OCT_PRIVATE = new Set(['k']);
Object.freeze(OCT_PRIVATE); // Octet sequence Key Type

var OctKey =
/*#__PURE__*/
function (_Key) {
  "use strict";

  _inherits(OctKey, _Key);

  function OctKey() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OctKey);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OctKey)).call.apply(_getPrototypeOf2, [this].concat(args)));
    Object.defineProperties(_assertThisInitialized(_this), {
      kty: {
        value: 'oct',
        enumerable: true
      },
      length: {
        value: _this[KEYOBJECT] ? _this[KEYOBJECT].symmetricKeySize * 8 : undefined
      },
      k: {
        enumerable: false,
        get: function get() {
          if (this[KEYOBJECT]) {
            Object.defineProperty(this, 'k', {
              value: base64url.encodeBuffer(this[KEYOBJECT].export()),
              configurable: false
            });
          } else {
            Object.defineProperty(this, 'k', {
              value: undefined,
              configurable: false
            });
          }

          return this.k;
        },
        configurable: true
      }
    });
    return _this;
  }

  _createClass(OctKey, [{
    key: THUMBPRINT_MATERIAL,
    // https://tc39.github.io/ecma262/#sec-ordinaryownpropertykeys no need for any special
    // JSON.stringify handling in V8
    value: function value() {
      if (!this[KEYOBJECT]) {
        throw new TypeError('reference "oct" keys without "k" cannot have their thumbprint calculated');
      }

      return {
        k: this.k,
        kty: 'oct'
      };
    }
  }, {
    key: KEY_MANAGEMENT_ENCRYPT,
    value: function value() {
      return new Set([].concat(_toConsumableArray(this.algorithms('wrapKey')), _toConsumableArray(this.algorithms('deriveKey'))));
    }
  }, {
    key: KEY_MANAGEMENT_DECRYPT,
    value: function value() {
      return this[KEY_MANAGEMENT_ENCRYPT]();
    }
  }, {
    key: "algorithms",
    value: function algorithms() {
      var _Key$prototype$algori;

      if (!this[KEYOBJECT]) {
        return new Set();
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_Key$prototype$algori = Key.prototype.algorithms).call.apply(_Key$prototype$algori, [this].concat(args));
    }
  }], [{
    key: "generate",
    value: function generate() {
      var _args = arguments;
      return _regeneratorRuntime.async(function generate$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.generateSync.apply(this, _args));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "generateSync",
    value: function generateSync() {
      var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 256;
      var privat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!privat) {
        throw new TypeError('"oct" keys cannot be generated as public');
      }

      if (!Number.isSafeInteger(len) || !len || len % 8 !== 0) {
        throw new TypeError('invalid bit length');
      }

      return createSecretKey(randomBytes(len / 8));
    }
  }, {
    key: PUBLIC_MEMBERS,
    get: function get() {
      return OCT_PUBLIC;
    }
  }, {
    key: PRIVATE_MEMBERS,
    get: function get() {
      return OCT_PRIVATE;
    }
  }]);

  return OctKey;
}(Key);

module.exports = OctKey;